import murmur3 from "murmurhash-js/murmurhash3_gc";

import { RibbonTopBarProps, RibbonTopBarScalingState } from ".";
import { TabHeader } from "../TabList/TabList.Props";

function getLayoutPropsFromTabHeaders(tabHeaders: TabHeader[]) {
  return tabHeaders.map((tab) => ({
    title: tab.title,
    tabType: tab.tabType,
  }));
}

function getCacheKeyForRibbonTopBar(
  topBarProps: RibbonTopBarProps,
  scalingState: RibbonTopBarScalingState
): string {
  const layoutProps = {
    tabList: getLayoutPropsFromTabHeaders(topBarProps.ribbonTabs),
    overflowTabCount: scalingState.overflowTabCount,
  };

  return murmur3(JSON.stringify(layoutProps)).toString(36);
}

export function addLayoutCacheKeyToRibbonTopBarState(
  topBarProps: RibbonTopBarProps,
  scalingState?: RibbonTopBarScalingState
): (RibbonTopBarScalingState & { cacheKey: string }) | undefined {
  if (scalingState === undefined) {
    return undefined;
  }
  return {
    ...scalingState,
    cacheKey: getCacheKeyForRibbonTopBar(topBarProps, scalingState),
  };
}
